import React, { useContext, useEffect, useState } from "react"
import * as styles from "./Filter.module.less"
import { SpaceTypeSwitcher, TeamSizeList } from "../../SearchParams/formField"
import DatePicker from "react-datepicker"
import { addMonths, format } from "date-fns"
import { SpaceProfileContext } from "../context"
import qs from "query-string"
import isOnDemand from "../../../utils/isOnDemand"

const Filters = ({ uuid = "", active, setActive = () => null }) => {
  const {
    commonData: { teamSize, moveInDate, data },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  const [displayDate, setDisplayDate] = useState(
    moveInDate ? format(moveInDate, "MMM do") : ""
  )

  const [pickerDate, setPickerDate] = useState(moveInDate || new Date())

  const setTeamSize = (team_size, space_type) => {
    if (uuid) {
      window.location.href = `${
        window.location.origin
      }/space/${uuid}?${qs.stringify({
        team_size,
        space_type,
        scroll: true,
      })}`
      return
    }
    updateUrl(team_size, null, space_type)
    setValue({
      teamSize: team_size,
      space_type,
      spaceSummary: qs.parse(window.location.search),
    })
    setActive(0)
  }

  const setDate = (moveInDate) => {
    setPickerDate(moveInDate)
    setDisplayDate(format(moveInDate, "MMM do"))
    setActive(0)
    updateUrl(null, moveInDate)
    setValue({ moveInDate, spaceSummary: qs.parse(window.location.search) })
  }

  const updateUrl = (
    teamSize = null,
    moveInDate = null,
    space_type = "Private Offices"
  ) => {
    const params = qs.parse(window.location.search)
    if (moveInDate) {
      params.move_in_date = format(moveInDate, "yyyy-MM-dd")
    }
    if (teamSize) {
      params.team_size = teamSize
    }
    params.space_type = space_type
    const uri = `${window.location.pathname}?${qs.stringify(params)}`
    window.history.pushState({}, "", uri)
  }

  useEffect(() => {
    window.addEventListener("click", () => setActive(0))
    return () => {
      window.removeEventListener("click", () => setActive(0))
    }
  }, [])
  return (
    <ul className={`${styles.list}`}>
      <li onClick={(e) => e.stopPropagation()}>
        <button
          className={`${styles.button} ${teamSize ? styles.active : ""}`}
          onClick={() => setActive(1)}
        >
          {teamSize
            ? `${teamSize} ${teamSize === 1 ? "person" : "people"}`
            : "Team size"}
        </button>
        {active === 1 && (
          <div className={styles.ts_wrapper}>
            <div className="team-size-selector show">
              <TeamSize updateValues={setTeamSize} teamSize={teamSize} />
            </div>
          </div>
        )}
      </li>
      <li onClick={(e) => e.stopPropagation()}>
        <button
          className={`${styles.button} ${displayDate ? styles.active : ""}`}
          onClick={() => {
            if (teamSize) setActive(2)
          }}
          disabled={!teamSize}
        >
          {displayDate || "Move-in date"}
        </button>
        {active === 2 && (
          <div className={styles.ts_wrapper}>
            <div className="team-size-selector show weekend-disabled">
              <DatePicker
                selected={pickerDate}
                onChange={setDate}
                inline
                showPopperArrow={false}
                className={"weekend-disabled"}
                minDate={new Date()}
                maxDate={addMonths(new Date(), 3)}
              />
            </div>
          </div>
        )}
      </li>
    </ul>
  )
}

export default Filters

const TeamSize = ({ teamSize, updateValues = () => null }) => {
  const [showSpaceType, setShowSpaceType] = useState(false)
  const [spaceType, setSpaceType] = useState("Private Office")
  const [ts, setTeamSize] = useState(teamSize)

  const {
    commonData: { data },
  } = useContext(SpaceProfileContext)

  const updateTeamSize = (teamSize) => {
    if (
      Number(teamSize) < 3 &&
      !isOnDemand() &&
      data.dedicated_desks_description
    ) {
      setShowSpaceType(true)
      setTeamSize(teamSize)
    } else {
      updateValues(teamSize, "Private Offices")
    }
  }

  const setSpaceTypeAndSearch = (type) => {
    setSpaceType(type)
    updateValues(ts, type)
  }

  return (
    <>
      {showSpaceType ? (
        <SpaceTypeSwitcher
          search={setSpaceTypeAndSearch}
          back={() => setShowSpaceType(false)}
        />
      ) : (
        <TeamSizeList updateTeamSize={updateTeamSize} value={ts} />
      )}
    </>
  )
}
